import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EPermissions } from '@enums/permissions.enum';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';
import { CampaignsBannerComponent } from './campaigns-banner/campaigns-banner.component';
import { CampaignsDatatableComponent } from './campaigns-datatable/campaigns-datatable.component';
import { CampaignsStore } from './campaigns.store';
import { CreateCampaignDialogComponent } from './create-campaign-dialog/create-campaign-dialog.component';

@Component({
  imports: [CampaignsDatatableComponent, CampaignsBannerComponent, ContentContainerComponent],
  providers: [CampaignsStore],
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
})
export class CampaignsComponent {
  public readonly addButtonConfiguration: ICreateEntityButtonConfiguration = {
    labelKey: 'pages.campaigns.datatable.newCampaign',
    onClick: this.onCreateClick.bind(this),
    permissions: [EPermissions.campaignCreate],
  };

  public readonly store = inject(CampaignsStore);
  private readonly dialog = inject(MatDialog);

  constructor() {
    this.store.fetchCampaigns({
      params: { limit: 5, sort: [{ active: 'created_at', direction: 'desc' }] },
    });
  }

  private onCreateClick(): void {
    this.dialog.open(CreateCampaignDialogComponent, {
      autoFocus: true,
      data: {
        campaign: null,
      },
      minWidth: '700px',
    });
  }
}
